import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveForm } from "../../redux/Reducer/Admin/PartnerSlice";
import Loader from "../Loader";
import { setOrderById } from "../../redux/Reducer/Order/OrderSlice";
import ArrowDown from "../common/icons/ArrowDown";
import { debounce } from "lodash";
import {
  searchRecordsOfStore,
} from "../../redux/Thunk/Order/OrderThunks";
import { useOutsideClick } from "../common/useOutsideClick";

const SearchSelectedOrders = ({ selectedOrder, setSelectedOrder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState([]);
  const [orders, setOrders] = useState([]);
  const dispatch = useDispatch();

  const {
    recordList: orderList,
    loading,
    orderById,
  } = useSelector((state) => state?.order);

  const handleClickOutside = (event) => {
    if (
      dropdownStoreRef?.current &&
      !dropdownStoreRef?.current?.contains(event?.target)
    ) {
      setSearchTerm("");
      setIsOpen(false);
      dispatch(searchRecordsOfStore({ id: "" }));
    }
  };
  const dropdownStoreRef = useOutsideClick(handleClickOutside);

  useEffect(() => {
    dispatch(setActiveForm(""));
  }, [dispatch]);

  useEffect(() => {
    if (orderList?.data?.length > 0) {
      let filteredOrders = orderList?.data?.filter(
        (order) => !order?.isCancelled
      );
      setOrders(filteredOrders);
    }
  }, [orderList]);

  useEffect(() => {
    if (!orderById && !orderById?.OID) {
      setSelectedOrder("");
    } else {
      setSelectedOrder(orderById);
    }
  }, [orderById, setSelectedOrder]);

  useEffect(() => {
    if (searchTerm?.length > 0) {
      const filteredOrders = orders?.filter((order) => {
        const searchLower = searchTerm.toLowerCase();
        const fullName = `${order?.patientDetail?.name || ""} ${
          order?.patientDetail?.surname || ""
        }`.toLowerCase();

        const fullNameMatch = fullName?.includes(searchLower);

        return fullNameMatch;
      });
      setOrders(filteredOrders);
    } else {
      setOrders(orderList?.data);
    }
  }, [searchTerm, orderList?.data, orders]);

  const handleToggleDropdown = () => {
    setIsOpen((prev) => {
      const newState = !prev;
      if (!newState) return newState;
      setTimeout(() => {
        const input = document.getElementById("search");
        input?.focus();
      }, 0);
      return newState;
    });
  };

  const handleSelectOrder = (order) => {
    dispatch(setOrderById(order));
    dispatch(setActiveForm(""));
    setSelectedOrder(order);
    setIsOpen(false);
  };

  const handleClearSearch = (e) => {
    e.stopPropagation();
    setSelectedOrder("");
    dispatch(setOrderById({}));
    setIsOpen(false);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Get day and pad with '0' if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const debouncedSearch = React.useMemo(
    () =>
      debounce((id) => {
        dispatch(searchRecordsOfStore({ id }));
      }, 500),
    [dispatch]
  );

  const handleChange = (e) => {
    e.preventDefault();
    const id = e?.target?.value?.trimStart();

    setSearchTerm(id);

    if (id === "" || /^\d+$/.test(id)) {
      debouncedSearch(id);
    }
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <div
        ref={dropdownStoreRef}
        onClick={handleToggleDropdown}
        className="p-4 bg-gray-100 h-auto text-gray-700 border border-gray-300 rounded cursor-pointer flex justify-between items-center"
      >
        <span>
          {Object.keys(selectedOrder)?.length ? (
            <>
              #{selectedOrder?.OID} <br />
              {formatDate(selectedOrder?.createdAt)} •{" "}
              {selectedOrder?.patientDetail?.name}{" "}
              {selectedOrder?.patientDetail?.surname}
            </>
          ) : (
            "Search or Select Order"
          )}
        </span>

        {!Object.keys(selectedOrder)?.length && (
          <button className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none">
            <ArrowDown />
          </button>
        )}
        {Object.keys(selectedOrder)?.length ? (
          <button
            onClick={handleClearSearch}
            className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              className="w-4 h-4"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        ) : null}
      </div>
      {isOpen && (
        <div className="absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-50 ">
          <input
            id="search"
            type="text"
            placeholder="Search order..."
            value={searchTerm}
            onChange={(e) => handleChange(e)}
            className="w-full p-2 border-b border-gray-300 focus:outline-none rounded-t-md"
          />
          {loading ? <Loader loading={loading} /> : null}
          <ul className="max-h-[calc(90vh_-_150px)] overflow-y-auto">
            {orders?.length > 0 ? (
              orders?.map((order) => (
                <li
                  key={order?.OID || order?.order?.OID}
                  onClick={() => handleSelectOrder(order)}
                  className="p-4 cursor-pointer hover:bg-gray-100 flex items-center gap-3"
                >
                  <div className="font-bold text-gray-800">{order?.name}</div>
                  <div className="text-sm text-gray-500">
                    #{order?.OID || ""} <br />
                    {formatDate(order?.createdAt)} •{" "}
                    {order?.patientDetail?.name} {order?.patientDetail?.surname}
                  </div>
                </li>
              ))
            ) : (
              <div className="pt-5 text-gray-500 text-center">
                No orders found
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchSelectedOrders;
